var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg625(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#EBE3D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.823 49.3407C135.067 45.7255 147.789 41.9688 172 50.2769V150.402C147.789 142.094 135.067 145.851 122.823 149.466C116.301 151.392 109.915 153.277 102 153.277C94.0939 153.277 87.8484 151.396 81.4632 149.472C69.4577 145.855 56.9585 142.089 32 150.402L32 50.2769C56.9585 41.964 69.4577 45.7298 81.4632 49.3469C87.8484 51.2707 94.0939 53.1523 102 53.1523C109.915 53.1523 116.301 51.2666 122.823 49.3407Z",
    fill: "#F7F4ED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.4814,
    y: 80.3491,
    width: 23.296,
    height: 3.4944,
    transform: "rotate(-50 52.4814 80.3491)",
    fill: "#3F3F3F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.4971,
    y: 83.7183,
    width: 23.296,
    height: 3.4944,
    transform: "rotate(-50 56.4971 83.7183)",
    fill: "#3F3F3F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5117,
    y: 87.0874,
    width: 23.296,
    height: 3.4944,
    transform: "rotate(-50 60.5117 87.0874)",
    fill: "#3F3F3F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63.4814,
    y: 107.349,
    width: 23.296,
    height: 3.4944,
    transform: "rotate(50 63.4814 107.349)",
    fill: "#3F3F3F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4658,
    y: 110.718,
    width: 10.7744,
    height: 3.4944,
    transform: "rotate(50 59.4658 110.718)",
    fill: "#3F3F3F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 67.5146,
    y: 120.311,
    width: 10.7744,
    height: 3.4944,
    transform: "rotate(50 67.5146 120.311)",
    fill: "#3F3F3F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 55.4512,
    y: 114.087,
    width: 23.296,
    height: 3.4944,
    transform: "rotate(50 55.4512 114.087)",
    fill: "#3F3F3F"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 135.481,
    y: 62.3491,
    width: 10.7744,
    height: 3.4944,
    transform: "rotate(50 135.481 62.3491)",
    fill: "#3F3F3F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 143.53,
    y: 71.9414,
    width: 10.7744,
    height: 3.4944,
    transform: "rotate(50 143.53 71.9414)",
    fill: "#3F3F3F"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 131.466,
    y: 65.7183,
    width: 23.296,
    height: 3.4944,
    transform: "rotate(50 131.466 65.7183)",
    fill: "#3F3F3F"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 127.451,
    y: 69.0874,
    width: 10.7744,
    height: 3.4944,
    transform: "rotate(50 127.451 69.0874)",
    fill: "#3F3F3F"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 135.5,
    y: 78.6797,
    width: 10.7744,
    height: 3.4944,
    transform: "rotate(50 135.5 78.6797)",
    fill: "#3F3F3F"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 124.481,
    y: 125.349,
    width: 10.7744,
    height: 3.4944,
    transform: "rotate(-50 124.481 125.349)",
    fill: "#3F3F3F"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 132.53,
    y: 115.757,
    width: 10.7744,
    height: 3.4944,
    transform: "rotate(-50 132.53 115.757)",
    fill: "#3F3F3F"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 128.497,
    y: 128.718,
    width: 10.7744,
    height: 3.4944,
    transform: "rotate(-50 128.497 128.718)",
    fill: "#3F3F3F"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 136.546,
    y: 119.126,
    width: 10.7744,
    height: 3.4944,
    transform: "rotate(-50 136.546 119.126)",
    fill: "#3F3F3F"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 132.512,
    y: 132.087,
    width: 10.7744,
    height: 3.4944,
    transform: "rotate(-50 132.512 132.087)",
    fill: "#3F3F3F"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 140.561,
    y: 122.495,
    width: 10.7744,
    height: 3.4944,
    transform: "rotate(-50 140.561 122.495)",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.533 110.99C124.807 105.751 125.865 99.4249 124.476 93.4047C123.086 87.3846 119.361 82.1632 114.122 78.8891C108.882 75.615 102.556 74.5564 96.5362 75.9463C90.5161 77.3361 85.2946 81.0605 82.0205 86.3002C78.6115 91.7557 80.2706 98.9418 85.7261 102.351C91.1816 105.76 98.3677 104.101 101.777 98.6452C105.186 93.1897 112.372 91.5307 117.827 94.9396C123.283 98.3486 124.942 105.535 121.533 110.99Z",
    fill: "#D7545E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0214 86.3003C78.7473 91.5399 77.6887 97.8656 79.0786 103.886C80.4685 109.906 84.1929 115.127 89.4325 118.401C94.6722 121.676 100.998 122.734 107.018 121.344C113.038 119.954 118.26 116.23 121.534 110.99C124.943 105.535 123.284 98.3487 117.828 94.9397C112.373 91.5308 105.187 93.1898 101.778 98.6453C98.3686 104.101 91.1825 105.76 85.727 102.351C80.2715 98.9419 78.6124 91.7558 82.0214 86.3003Z",
    fill: "#5858B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg625);
export default __webpack_public_path__ + "static/media/625.b1e979d4775b64612fc77e939cd4eca8.svg";
export { ForwardRef as ReactComponent };